import { z } from "zod";

const translationPath = "components.settingsCache.settingsCacheKey.errors.";

export const settingsCacheKeySchema = z.object({
  key: z.string().nonempty(translationPath + "cache_key"),
});

export type TSettingsCacheKeyForm = z.infer<typeof settingsCacheKeySchema>;
